'use strict';

const propTypes = require('prop-types');
const React = require('react');
const { string, object } = propTypes;
// This are used to populate the caveat at the bottom of the table
let startDate;
let endDate;
let dateUsed;
const createReactClass = require('create-react-class');

const hotelParkingTable = createReactClass({

  getDefaultProps( ) {
    return {
      terminal: ''
    };
  },

  propTypes: {
    id: string.isRequired,
    terminal: string,
    pageData: object,
    location: object,
    setVar: object,
    domainSettings: object
  },

  getType(productClass) {
    if (productClass === 'HCP' || productClass === 'HO') return 'hotelLocations';
    if (productClass === 'LO') return 'loungeLocations';
    return 'parkingLocations';
  },

  getTableDataFromFeed( ) {
    const { location, pageData: { productClass }, terminal, setVar = { }, domainSettings: { contentStaticServer } } = this.props;
    const allowedColumns = {
      'HO': {
        title: true,
        address: true,
        perWeekPrice: true,
        starRating: true,
        logo: true,
        pageName: true,
        disclaimer: true
      },
      'HCP': {
        title: true,
        address: true,
        perWeekPrice: true,
        starRating: true,
        logo: true,
        pageName: true,
        disclaimer: true
      },
      'LO': {
        title: true,
        times: true,
        rating: true,
        lowestPrice: true,
        logo: true
      },
      'CP': {
        title: true,
        perDayPrice: true,
        perWeekPrice: true,
        distance: true,
        transfers: true,
        rating: true
      }
    };
    try {
      const type = this.getType(productClass.toUpperCase());
      let tableData = require('../../../../../config/exports/' + type + '/' + location.code + (terminal.length > 0 ? '_' + terminal : '') + '.json');
      tableData = this.makeTableObject(tableData, contentStaticServer, type);
      return this.makeTableRow(tableData, setVar, allowedColumns, productClass);
    } catch (e) {
      return false;
    }
  },


  // Create each table row object how we need it
  makeTableObject(tableData, contentStaticServer, type) {
    const output = [ ];
    Object.keys(tableData).map(key => {
      const item = tableData[key];
      if (!item.prodlib) return;
      let {
        tripappcarparkname,
        tripapphotelname,
        tripappaddonname,
        name,
        on_airport: onAirport,
        address,
        transfer_time: transferTime,
        transfers_included_in_price: transfersIncludedInPrice,
        free_transfers: freeTransfers,
        transfer_price: transferPrice,
        distance_miles: distanceMiles,
        meet_and_greet: meetAndGreet,
        wistia_key: wistiaKey,
        openingtime: openingTime,
        closingtime: closingTime,
        tripappimages,
        _prodcode,
        logo
      } = item.prodlib;

      const productName = tripappcarparkname || tripapphotelname || tripappaddonname || item.title || name;
      const pageName = item.pagename && item.pagename.replace('"', '');
      onAirport = parseInt(onAirport, 10);

      let transferText = 'Not required';
      if (transferTime) {
        transferText = transferTime + ' mins';
      } else if (transfersIncludedInPrice || freeTransfers || (transferPrice && (/FREE/gi).test(transferPrice))) {
        transferText = 'Included';
      }

      const distanceUnits = parseFloat(distanceMiles, 10).toFixed(1);
      let distanceText = distanceUnits + ' miles';
      if (!distanceMiles) distanceText = '0.0 miles';
      if (parseInt(meetAndGreet, 10)) {
        distanceText = 'On airport';
      } else if (onAirport) {
        distanceText = 'On airport';
      }

      let perDayPrice, perWeekPrice, lowestPrice;
      if (item.price) {
        startDate = item.price.startDate;
        endDate = item.price.endDate;
        dateUsed = item.price.dateUsed;
        lowestPrice = item.price.lowestPrice;
        perDayPrice = item.price.per_day || item.price.lowestDays0;
        perWeekPrice = item.price.per_week || item.price.lowestDays8;
      }
      const perDayUnits = perDayPrice || '0.00';
      const perWeekUnits = perWeekPrice || '0.00';

      let starRatingOutput = '';
      for (let i = 0; i < item.prodlib.star_rating; i++) {
        starRatingOutput += '★';
      }

      if (logo && contentStaticServer) {
        if ( tripappimages ) logo = tripappimages.split(';')[0].replace('/imageLibrary/Images', contentStaticServer + '/libraryimages/Images');
        else logo = logo.replace('/imageLibrary/Images', contentStaticServer + '/libraryimages/Images');
      }

      output.push({
        productName,
        _prodcode,
        pageName,
        linkTitle: item.title || name,
        name,
        address: address && address.replace(/(<br \/>|<br>|<br\/>)/g, ' '),
        extraLinks: item.links,
        score: type === 'hotelLocations' ? false : item.score,
        starRating: item.prodlib.star_rating,
        starRatingOutput,
        wistiaKey,
        transferText,
        distanceUnits,
        distanceText,
        openingTime,
        closingTime,
        perDayPrice,
        perWeekPrice,
        perDayUnits,
        perWeekUnits,
        tripappimages,
        lowestPrice,
        logo,
        type
      });
    });
    return output;
  },

  makeTableRow(tableRows = [ ], setVar, allowedColumns, type) {
    return tableRows.map((tableRow, key) => {
      if (!tableRow._prodcode || (/(mystery|undercover)/gi).test(tableRow.productName) || (/(mystery|undercover)/gi).test(tableRow.pageName)) return;
      return (
        <div key={key} data-productcode={tableRow._prodcode} className="item col-md-4 col-sm-6 col-xs-12">
          <div className="inner">
            { allowedColumns[type].logo && (
              <div data-sort-value={tableRow.logo} className="center">
                <img src={tableRow.logo} title={tableRow.title} width="100%" />
              </div>
            )}
            <div className="productTitle">
              <h3>
                { tableRow.pageName && allowedColumns[type].title ? (
                  <a href={tableRow.pageName} className="hotelname show bold" title={tableRow.linkTitle}>{ tableRow.name }</a>
                ) : tableRow.name }
              </h3>
              { tableRow.address && (
                <small className="prodAddress hidden-xs">{ tableRow.address }</small>
              )}

              { tableRow.extraLinks && tableRow.extraLinks.directions && (
                <a className="table-link directionsLink" href={'/' + tableRow.extraLinks.directions + '.html'} title="Map and Directions">Map & Directions</a>
              )}
              { tableRow.extraLinks && tableRow.extraLinks.photos && (
                <a className="table-link photosLink" href={'/' + tableRow.extraLinks.photos + '.html'} title="Photos">Photos</a>
              )}
              { tableRow.wistiaKey && (
                <a href="#" data-newwindow={'http://fast.wistia.net/embed/iframe/' + tableRow.wistiaKey + '?autoPlay=true&controlsVisibleOnLoad=true&playButton=false&playerColor=F36F36&popover=true&version=v1&videoHeight=180&videoWidth=320'} className="table-link wistia-popover[height=180,playerColor=7b796a,width=320]">Video</a>
              )}
              { tableRow.extraLinks && tableRow.extraLinks.reviews && (
                <a className="table-link" href={'/' + tableRow.extraLinks.reviews + '.html'} title="Customer Reviews">Reviews</a>
              )}
            </div>
            <hr />

            { allowedColumns[type].starRating && (
              <div data-sort-value={tableRow.starRating}>
                { tableRow.starRating && (
                  <strong className="bold stars">{ tableRow.starRatingOutput }</strong>
                )}
              </div>
            )}

            { allowedColumns[type].perDayPrice && (
              <div data-sort-value={tableRow.perDayUnits}>
                { tableRow.perDayPrice && !setVar.hideTablePrices && (
                  <strong className="bold purple purplePrice tableTooltip" data-toggle="tooltip" data-placement="top" title="This is a guide price only">&pound;{ tableRow.perDayPrice }*</strong>
                )}
              </div>
            )}
            { allowedColumns[type].perWeekPrice && (
              <div data-sort-value={tableRow.perWeekUnits}>
                { tableRow.perWeekPrice && !setVar.hideTablePrices && (
                  <strong className="bold purple purplePrice tableTooltip" data-toggle="tooltip" data-placement="top" title="This is a guide price only">
                    <div>&pound;{ tableRow.perWeekPrice }*</div>
                  </strong>
                )}
              </div>
            )}

            { allowedColumns[type].disclaimer && tableRow.perWeekPrice && !setVar.hideTablePrice && (
              <small className="disclaimer">*Price based on 7 days parking</small>
            )}

            { allowedColumns[type].distance && (
              <div data-sort-value={tableRow.distanceUnits} className="center miles hidden-xs">
                { tableRow.distanceText }
              </div>
            )}
            { allowedColumns[type].transfers && (
              <div className="hidden-xs">
                { tableRow.transferText }
              </div>
            )}
            { allowedColumns[type].times && (
              <div>
                { tableRow.openingTime && tableRow.closingTime ? (
                  <small><span className="reviewPercent tableTooltip" data-placement="top" title={'This lounge is open from ' + tableRow.openingTime + ' until ' + tableRow.closingTime} >Open from <strong>{ tableRow.openingTime }</strong> to <strong> { tableRow.closingTime } </strong></span></small>
                ) : (null)}
              </div>
            )}
            { allowedColumns[type].rating && (
              <td className="hidden-xs lo">
                { tableRow.score && tableRow.score.averageAsPercentage ? (
                  <span className="reviewPercent tableTooltip" data-toggle="tooltip" data-placement="top" title={tableRow.score.averageAsPercentage + '% of ' + tableRow.score.count + ' guests said they would use this car park again.'} rel={tableRow.score.count}>{ tableRow.score.averageAsPercentage }%</span>
                ) : (null)}
              </td>
            )}
            { allowedColumns[type].lowestPrice && (
              <div data-sort-value={tableRow.lowestPrice}>
                { tableRow.lowestPrice && !setVar.hideTablePrices && (
                  <strong className="bold purple purplePrice tableTooltip" data-toggle="tooltip" data-placement="top" title="This is a guide price only">&pound;{ tableRow.lowestPrice }*</strong>
                )}
              </div>
            )}
          </div>
        </div>
      );
    });
  },

  render() {
    const { id, pageData } = this.props;
    const tableContents = this.getTableDataFromFeed();
    if (!tableContents) {
      return (
        <span id={id} />
      );
    }

    return (
      <div>
        <div id={id} className="table table-condensed table-striped product-table-slim hxTableSort">
          { tableContents }
        </div>
        { pageData.pageName !== 'humberside-airport-parking' && pageData.productClass.toUpperCase() === 'CP' && (
          <p>*This is an example price for reservations between { startDate } and { endDate }, valid as of { dateUsed }.  The price per week is the total cost of this car parking for 8 days. The price per day refers to the same product and period, divided by 8.</p>
        )}
        { pageData.productClass.toUpperCase() !== 'CP' && (
          <p>*This is an example price for a reservation on { startDate }, valid as of { dateUsed }.</p>
        )}
      </div>
    );
  }
});

module.exports = hotelParkingTable;





// WEBPACK FOOTER //
// ./shared/_layouts/_templates/_includes/tables/productTable.jsx